import { refreshWithToken } from './auth';
import axios from 'axios';
import { store } from '../app/store';
import { logout, refreshToken } from '../features/currentUser/currentUserSlice';
import { QueryClient } from '@tanstack/react-query';

//const fallOffApi = 'http://localhost:3000';

// const fallOffApi = 'https://api-dev.raqt.com';

const fallOffApi = 'https://api.raqt.com';

//

export const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || fallOffApi,
});

export const queryClient = new QueryClient();

api.interceptors.request.use((config) => {
  const state = store.getState();

  if (state.currentUser.accessToken) {
    return {
      ...config,
      headers: {
        ...config.headers,
        authorization: `Bearer ${state.currentUser.accessToken}`,
      },
    };
  }
  return config;
});

api.interceptors.response.use(undefined, async (error) => {
  const originalRequest = error.config;
  const state = store.getState();
  const initialRefreshToken = state.currentUser.refreshToken;
  console.log(error);
  if (error.response?.request?.responseURL?.includes('refresh')) {
    return Promise.reject(error);
  }

  if (
    error.response?.status === 401 &&
    !originalRequest._retry &&
    initialRefreshToken
  ) {
    originalRequest._retry = true;

    try {
      const token = await refreshWithToken(initialRefreshToken);
      store.dispatch(refreshToken(token));
      return api({
        ...originalRequest,
        headers: {
          ...originalRequest.headers,
          authorization: `Bearer ${token.accessToken}`,
        },
      });
    } catch (e) {
      // Only logout if session hasn't changed (no new login happened)
      const currentState = store.getState();
      if (currentState.currentUser.refreshToken === initialRefreshToken) {
        store.dispatch(logout());
      }
    }
  } else if (
    error.response?.status === 401 &&
    (originalRequest._retry || !initialRefreshToken)
  ) {
    const currentState = store.getState();
    if (currentState.currentUser.refreshToken === initialRefreshToken) {
      store.dispatch(logout());
    }
  }

  return Promise.reject(error);
});
